import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'cpdtimeonly'})
export class CPDtimeonly implements PipeTransform {
  transform(value: number): string {
    if(value<60){
      return value+'mins';
    }
    else{
    var hours = (value / 60);
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    if (rminutes < 10) return rhours+':0'+rminutes+'hrs';
    return rhours+':'+rminutes+'hrs';
    }
  }
}